// extracted by css-extract-rspack-plugin
export default {"ProductAnnouncementBannerAnimation":"ProductAnnouncementBannerAnimation-module__ProductAnnouncementBannerAnimation__LKbY9nT"};